import auth from '@/router/auth'
import SettingUpdate from '@/components/settings/Update'
import SettingShow from '@/components/settings/Show'

export default [
  {
    path: '/settings/update/:id',
    name: 'settings-update',
    component: SettingUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/settings/show/:id',
    name: 'settings-show',
    component: SettingShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/settings/router.js